import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SignatureBox from 'components/SignatureBox';
import S from 'modal.scss';

class ApprovalSignature extends Resetter(Validator(React.Component)) {
  state = {
    contractorSignature: this.props.contractorSignature || '',
    clearSignature: 0,
    errors: {},
  }

  static VALIDATIONS = {
    contractorSignature: true,
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      contractorSignature: this.state.contractorSignature,
      tab: 3,
    });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      contractorSignature: this.state.contractorSignature,
      tab: 1,
    });
  }

  handleSignatureChange = (data) => {
    this.setState({ contractorSignature: data });
  }

  handleClear = () => {
    this.setState({
      contractorSignature: '',
      clearSignature: Date.now(),
    });
  }

  render() {
    const { clearSignature, errors } = this.state;
    return (
      <Fragment>
        <SignatureBox
          required
          label="Sign Contractor's Name *"
          clearTimestamp={clearSignature}
          errors={errors.contractorSignature}
          onEnd={this.handleSignatureChange}
          onClear={this.handleClear}
        />
        <Button label="Approve" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
        <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
      </Fragment>
    );
  }
}

ApprovalSignature.propTypes = {
  errors: PropTypes.shape({
    contractorSignature: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: state.phase.laborSheets.errors }), {
})(ApprovalSignature);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/approveLabor/approvalSignature.jsx